import { ChartDisplaySettingsModel } from './chart-display-settings.model';


export class CoverageMetricChartDisplaySettings extends ChartDisplaySettingsModel {

    icon: boolean;
    customPreviousValue: number;
    sparkChart: boolean;

    constructor(api?: any) {
        super(api);
        if (api) {
            this.icon = api.icon ?? true;
            this.customPreviousValue = api.customPreviousValue;
            this.sparkChart = api.sparkChart ?? true;
        } else {
            this.icon = true;
            this.customPreviousValue = null;
            this.sparkChart = true;
        }
    }

    clone(): CoverageMetricChartDisplaySettings {
        return new CoverageMetricChartDisplaySettings(this);
    }
    public isEqual(other: CoverageMetricChartDisplaySettings) {
        if (!super.isEqual(other)) {
            return false;
        }
        if (this.icon !== other.icon) {
            return false;
        }
        if (this.customPreviousValue !== other.customPreviousValue) {
            return false;
        }
        if (this.sparkChart !== other.sparkChart) {
            return false;
        }
        return true;
    }
}
